import { useEffect, useState } from "react";

/**
 * Retourne la valeur avec un délai : tant que `value` change plus vite que
 * `delay`, la valeur débouncée ne bouge pas. Utilisé pour les champs de
 * recherche filtrant de grandes listes (paiements, coachs…).
 */
export function useDebounced<T>(value: T, delay = 250) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setV(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return v;
}
